import React from 'react';
import { getAppUrl, setAppUrl, getLocation } from '@platform/api';

export default function Iframe(props) {
    let { src, appcode, pagecode, custom, appname, ...others } = props;
    let urlKey = '';
    if (window.__QIANKUN_RUNCONTEXT?.runContext?.appInfo) {//内部页签去iframe模式
        let runContext = window.__QIANKUN_RUNCONTEXT.runContext;
        urlKey = runContext.appKey;
    } else {//iframe模式,获取当前url参数
        let param = getLocation(window).hash;
        if (param.includes('?')) {
            let search = param.split('?')[1];
            if(search.includes('&')){
                let urlKeyItem = search.split('&').find(e=>e.includes('urlKey='));
                if(urlKeyItem){
                    urlKey = decodeURIComponent(urlKeyItem.split('=')[1]);
                }
            }else if(search.includes('urlKey=')){
                urlKey = decodeURIComponent(search.split('=')[1]);
            }
        }
    }

    let iframeUrlKey = '';
    if(urlKey){
        iframeUrlKey = urlKey + '_inside_iframe';
        let newPathContext = {
            c: appcode, //必输
            p: pagecode, //必输
        };

        if(custom){ //非必输
            newPathContext.custom = custom;
        }
        if(appname){ //非必输
            newPathContext.n = appname;
        }
        let path = getAppUrl(iframeUrlKey).pageurl;
        let newPath = '';
        if(path && path.includes("&")){//更新参数
            let paramArr = path.split("&");
            newPath = paramArr.map( e => {
                let [key, value] = e.split('=');
                if(newPathContext[key]){
                    value = newPathContext[key];
                }
                return `${key}=${encodeURIComponent(value)}`;

            }).join('&');
        }else{//创建参数
            newPath = Object.keys(newPathContext).map( pop => {
                return `${pop}=${encodeURIComponent(newPathContext[pop])}`;

            }).join('&');
        }
            
        setAppUrl(iframeUrlKey, newPath);

        if(! src.includes('urlKey=')){
            src = src + (src.includes('?') ? '&' : '?') + 'urlKey=' + iframeUrlKey;
        }
    }

    console.log("iframe=======src", src);

    return src ? <iframe {...others} src={src} ></iframe> : null; 
}
